<template>
  <v-form @submit.prevent="addTrack" ref="form" data-testid="external-track-form">
    <v-text-field
      v-model="trackParams.preview_url"
      label="Audio file"
      prepend-icon="mdi-music"
      name="external_track__preview_url"
      required
      @click="uploadPreview"
    />
    <v-text-field
      v-model="trackParams.name"
      label="Name"
      name="external_track__name"
      required
    />
    <v-text-field
      v-model="trackParams.album_name"
      label="Album Name"
      name="external_track__album_name"
      required
    />
    <v-text-field
      v-model="trackParams.artist_name"
      label="Artist Name"
      name="external_track__artist_name"
      required
    />
    <v-text-field
      v-model="trackParams.release_date"
      label="Release Date"
      name="external_track__release_date"
      type="date"
      required
    />
    <v-text-field
      v-model="trackParams.image_url"
      label="Cover"
      name="external_track__image_url"
      @click="uploadCover"
    >
      <template #prepend>
        <v-img v-if="trackParams.image_url" :src="trackParams.image_url" height="24" width="24" />
        <v-icon v-else>mdi-image</v-icon>
      </template>
      </v-text-field>
      <v-btn type="submit" data-testid="external-track-submit">Add Track</v-btn>
  </v-form>
</template>
<script lang="ts">

import { defineComponent } from 'vue'
import cms from '@/cms'

interface TrackParamsForm {
  preview_url: string
  name: string
  album_name: string
  artist_name: string
  release_date: string
  image_url: string
}

export default defineComponent({
  data () {
    return {
      trackParams: {
        preview_url: '',
        name: '',
        album_name: '',
        artist_name: '',
        release_date: '',
        image_url: ''
      } as TrackParamsForm
    }
  },
  methods: {
    addTrack () {
      // TODO: Better validation
      if (!this.trackParams.preview_url || !this.trackParams.name || !this.trackParams.album_name || !this.trackParams.artist_name || !this.trackParams.release_date) {
        console.warn('Form is not valid', this.trackParams)
        return
      }

      this.$store.commit('ADD_CAMPAIGN_EXTERNAL_TRACK', {
        preview_url: this.trackParams.preview_url,
        name: this.trackParams.name,
        album_name: this.trackParams.album_name,
        artist_name: this.trackParams.artist_name,
        release_date: this.trackParams.release_date,
        images: [
          {
            url: this.trackParams.image_url,
            width: null,
            height: null
          }
        ]
      })

      // clear form
      this.trackParams = {
        preview_url: '',
        name: '',
        album_name: '',
        artist_name: '',
        release_date: '',
        image_url: ''
      }
    },
    async uploadPreview () {
      const ret = await cms.selectMediaFile({
        fieldId: 'preview_url',
        currentFileUrl: this.trackParams.preview_url,
      })
      this.trackParams.preview_url = ret.url
    },
    async uploadCover () {
      const ret = await cms.selectMediaFile({
        fieldId: 'image_url',
        currentFileUrl: this.trackParams.image_url,
        targetWidth: 640,
      })
      this.trackParams.image_url = ret.url
    }
  }
})
</script>
